import { cn } from "@/lib/utils";
import type { CopilotStatus } from "./StatusDot";

type BadgeStatus = CopilotStatus | "info";

const badgeStyles: Record<BadgeStatus, string> = {
  critical: "bg-copilot-critical-bg text-copilot-critical border-copilot-critical-border",
  warning: "bg-copilot-warning-bg text-copilot-warning border-copilot-warning-border",
  healthy: "bg-copilot-healthy-bg text-copilot-healthy border-copilot-healthy-border",
  neutral: "bg-copilot-neutral-bg text-copilot-neutral border-copilot-neutral-border",
  info: "bg-copilot-info-bg text-copilot-info border-copilot-info-border",
};

interface StatusBadgeProps {
  status: BadgeStatus;
  children: React.ReactNode;
  interactive?: boolean;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}

export function StatusBadge({
  status,
  children,
  interactive,
  active,
  onClick,
  className,
}: StatusBadgeProps) {
  return (
    <span
      role={interactive ? "button" : "status"}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={interactive ? (e) => { if (e.key === "Enter" || e.key === " ") onClick?.(); } : undefined}
      className={cn(
        "inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border whitespace-nowrap",
        badgeStyles[status],
        interactive && "cursor-pointer select-none transition-all hover:opacity-85",
        active && "ring-2 ring-copilot-brand scale-105",
        className
      )}
    >
      {children}
    </span>
  );
}
